const Heart = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none">
            <g clipPath="url(#clip0_141_16667)">
                <path
                    d="M13.0062 0.614321C10.312 -1.39456 7.49988 2.16672 7.49988 2.16672C7.49988 2.16672 4.68772 -1.39456 1.99355 0.614321C-1.28163 3.05482 0.951287 8.08324 7.49988 11.9998C14.0503 8.08146 16.2814 3.05482 13.0062 0.614321Z"
                    fill="#D2152D"
                />
            </g>
            <defs>
                <clipPath id="clip0_141_16667">
                    <rect width="14" height="12" fill="white" transform="translate(0.5 1.52588e-05)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Heart;
